
import { OrderCellStatus } from "components/Orders/Orders/Components/OrderCellStatus";

import { DisplayPrices, Order } from "../types";

const Title = ({ text }: { text: string }) => {
    return (
        <div className="text-sm font-medium text-base-foreground w-44 shrink-0">{text}</div>
    )
}

const Value = ({ value, dataTestId }: { value: string; dataTestId?: string }) => {
    return (
        <div className="text-sm text-base-mutedForeground font-light" data-testid={dataTestId}>{value}</div>
    )
}

const DetailRow = ({ title, value, dataTestId }: { title: string; value: string; dataTestId?: string }) => {
    return (
        <div className="flex items-center gap-8">
            <Title text={title} />
            <Value value={value} dataTestId={dataTestId} />
        </div>
    )
}

export const OrderDetails = ({ order, publisherId, displayPrices }: { order?: Order, publisherId: string | undefined, displayPrices: DisplayPrices | null }) => {
    if (!order || !displayPrices) return null;

    return (
        <div className="flex flex-col gap-8 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
            <div className="flex items-center gap-4">
                <h2 className="font-medium text-xl text-base-primary" data-testid="orderDetailsTotalPayment">Total Payment: {order.currencySymbol}{(displayPrices.amountNetTotal + displayPrices.taxTotal).toFixed(2)}</h2>
                <OrderCellStatus status={order.status} dataTestId="orderDetailsStatus" />
            </div>

            <div className="grid grid-cols-2 gap-y-5 w-[75%] pl-4">
                <DetailRow title="Date" value={new Date(order.createdAt).toLocaleString()} dataTestId="orderDetailsDate" />
                <DetailRow title="Payment Method" value={order.paymentMethod?.primaryMethod || 'N/A'} dataTestId="orderDetailsPaymentMethod" />

                <DetailRow title="Country" value={order.playerGeo.countryCode2} dataTestId="orderDetailsCountry" />
                <DetailRow title="Tax Rate" value={`${order.taxRatePoints / 100}%`} dataTestId="orderDetailsTaxRate" />

                <DetailRow title="State" value={order.playerGeo.state} dataTestId="orderDetailsState" />
                <DetailRow title="Player ID" value={order.playerId} dataTestId="orderDetailsPlayerId" />

                <DetailRow title="Postal Code" value={order.playerGeo.zipCode} dataTestId="orderDetailsPostalCode" />
                <DetailRow title="Player Email" value={order.playerEmail || 'N/A'} dataTestId="orderDetailsPlayerEmail" />
                <DetailRow title="Order ID" value={order._id} dataTestId="orderDetailsOrderId" />

                <DetailRow title="Offer Name" value={order.bundleName} dataTestId="orderDetailsOfferName" />
                <DetailRow title="Publisher Transaction ID" value={order.publisherPurchaseId || 'N/A'} dataTestId="orderDetailsTransactionId" />

                <DetailRow title="Offer External ID" value={order.bundleSku} dataTestId="orderDetailsOfferExternalId" />
                <DetailRow title="Project" value={publisherId ?? ''} dataTestId="orderDetailsProject" />

                <DetailRow title="Subtotal" value={`${order.currencySymbol}${displayPrices.amountNetTotal.toFixed(2)}`} dataTestId="orderDetailsSubtotal" />
                <DetailRow title="Receipt Number" value={order.receiptId || 'N/A'} dataTestId="orderDetailsReceiptNumber" />
            </div>
        </div>
    )
}   